import { useState, useEffect } from 'react';
import { useUserData } from '@/context/UserDataContext';
import { toast } from 'sonner';
import { Recommendation } from './useRecommendations';

export const useSavedRecommendations = () => {
  const { isDataComplete } = useUserData();
  const [recommendations, setRecommendations] = useState<Recommendation[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadSavedRecommendations = async () => {
      if (!isDataComplete) {
        return;
      }
      
      setIsLoading(true);
      setError(null);
      
      try {
        const savedRecommendations = localStorage.getItem('recommendations');
        if (!savedRecommendations) {
          throw new Error('No saved recommendations found');
        }

        const parsed = JSON.parse(savedRecommendations);
        if (!Array.isArray(parsed) || parsed.length === 0) {
          throw new Error('Invalid recommendations data');
        }

        setRecommendations(parsed);
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Failed to load recommendations';
        setError(message);
        toast.error(message);
      } finally {
        setIsLoading(false);
      }
    };

    loadSavedRecommendations();
  }, [isDataComplete]);

  return { recommendations, isLoading, error };
}; 